import { render, staticRenderFns } from "./CadastrarEditarUnidadeTematicaDialog.vue?vue&type=template&id=08b7dcf8"
import script from "./CadastrarEditarUnidadeTematicaDialog.vue?vue&type=script&lang=js"
export * from "./CadastrarEditarUnidadeTematicaDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports